module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "transition": "fade-transition",
      "max-width": "700px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [(_vm.reportData) ? _c('v-card', {
    staticStyle: {
      "min-width": "400px"
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("For your internal communication only")]), _vm._v(" "), _c('v-card-text', [(_vm.reportData.isTikTok && _vm.reportData.isTikTok === 'tiktok') ? _c('a', {
    attrs: {
      "href": 'https://www.tiktok.com/@' + _vm.reportData.instagram,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/tiktok-32.png",
      "width": "20px"
    }
  }), _vm._v(" @" + _vm._s(_vm.reportData.instagram))]) : _c('a', {
    attrs: {
      "href": 'https://www.instagram.com/' + _vm.reportData.instagram,
      "target": "_blank"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#000000",
      "small": ""
    }
  }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(_vm.reportData.instagram))], 1), _vm._v(" "), _c('v-row', {
    staticClass: "mt-2"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "name": "notes",
      "label": "",
      "hide-details": "",
      "value": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.reportData.note.$touch()
      }
    },
    model: {
      value: (_vm.reportData.note),
      callback: function($$v) {
        _vm.$set(_vm.reportData, "note", $$v)
      },
      expression: "reportData.note"
    }
  })], 1)], 1), _vm._v(" "), (_vm.reportData.internalNotes.length > 0) ? _c('v-row', [_c('v-col', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "cols": "12",
      "md": "12",
      "sm": "12",
      "lg": "12"
    }
  }, [_c('v-card', {
    staticClass: "overflow-hidden overflow-y-auto",
    attrs: {
      "flat": "",
      "max-height": "300px"
    }
  }, [(_vm.reportData.internalNotes.length > 0) ? _c('v-card-text', {
    staticClass: "mt-0 pt-0"
  }, _vm._l((_vm.reportData.internalNotes), function(msg, index) {
    return _c('element', {
      key: index
    }, [_c('v-row', [_c('v-col', [_c('p', {
      staticClass: "body-2 font-weight-bold"
    }, [_vm._v(_vm._s(msg.author ? msg.author.name : '-'))])]), _vm._v(" "), _c('v-col', {
      staticClass: "text-right"
    }, [(_vm.showAction(msg)) ? _c('v-btn', {
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "top",
        "title": "Delete Note",
        "color": "error",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteNote(_vm.fileIndex)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "white",
        "small": ""
      }
    }, [_vm._v("delete")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('p', {
      staticClass: "body-1 font-weight-medium"
    }, [_vm._v(_vm._s(msg.notes))]), _vm._v(" "), _c('p', {
      staticClass: "caption text-xs-right font-italic"
    }, [_vm._v(_vm._s(_vm.formatTime(msg.timestamp)))]), _vm._v(" "), _c('v-divider')], 1)
  }), 0) : _c('v-card-text', [_c('p', {
    staticClass: "body-1 fong-weight-bold"
  }, [_vm._v("\n                No Internal Notes\n              ")])])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveNote()
      }
    }
  }, [_vm._v("Save")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "90",
      "height.number": "90"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67c736d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Finance/reportNotesModal.vue
// module id = 2166
// module chunks = 0